import React, {useState} from 'react';
import './CortsChoice.css';

const CortsChoice = ({setCort, cort}) => {

    const [selectedCort, setSelectedCort] = new useState(0);

    const changeCort = (num) => {
        setSelectedCort(num);
        setCort(num);
    }

    return (
        <div className={'corts-and-description'}>
            <p className={'desktop-choose-cort-description-1'}>Выберите корт</p>
            <div className={'corts-container'}>
                <div className={'cort-choice-1'} onClick={() => changeCort(1)}>
                    <svg version="1.1" id="Layer_10" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                         viewBox="0 0 429.8 804.5">
                        <g>
                            <rect x="-187.4" y="187.5" transform="matrix(6.123234e-17 -1 1 6.123234e-17 -187.3548 617.1613)" className={selectedCort===1 ? 'cort-svg-selected' : 'cort-svg-not-selected'} width="804.6" height="429.6"/>
                        </g>
                        <g>
                            <path className="cort-svg-white-lines" d="M363,64H62.9v319.8h-5.1v2h5.1v318.5H363V385.8h1.2v-2H363V64z M320.5,551.2H216.6V385.8h0.5v-2h-0.5V218.1
                                h103.9V551.2z M212.6,383.8h-7.7v2h7.7v165.4H107.4V385.8H119v-2h-11.7V218.1h105.2V383.8z M107.4,555.2h213.1v139.1H107.4V555.2z
                                 M320.5,214.1H107.4V74h213.1V214.1z M72.9,74h30.5v620.3H72.9V74z M353,694.3h-28.5V74H353v309.8h-1.1v2h1.1V694.3z"/>
                                                <rect x="302.9" y="383.8" className="cort-svg-white-lines" width="12.3" height="2"/>
                                                <rect x="180.3" y="383.8" className="cort-svg-white-lines" width="12.3" height="2"/>
                                                <rect x="278.4" y="383.8" className="cort-svg-white-lines" width="12.3" height="2"/>
                                                <rect x="253.9" y="383.8" className="cort-svg-white-lines" width="12.3" height="2"/>
                                                <rect x="229.3" y="383.8" className="cort-svg-white-lines" width="12.3" height="2"/>
                                                <rect x="327.4" y="383.8" className="cort-svg-white-lines" width="12.3" height="2"/>
                                                <rect x="155.8" y="383.8" className="cort-svg-white-lines" width="12.3" height="2"/>
                                                <rect x="82.3" y="383.8" className="cort-svg-white-lines" width="12.3" height="2"/>
                                                <rect x="131.3" y="383.8" className="cort-svg-white-lines" width="12.3" height="2"/>
                                                <path className="cort-svg-white-lines" d="M39.9,377.3c-4.2,0-7.5,3.4-7.5,7.5c0,4.2,3.4,7.5,7.5,7.5c4.2,0,7.5-3.4,7.5-7.5
                                C47.4,380.7,44,377.3,39.9,377.3z"/>
                                                <path className="cort-svg-white-lines" d="M382.1,377.3c-4.2,0-7.5,3.4-7.5,7.5c0,4.2,3.4,7.5,7.5,7.5c4.2,0,7.5-3.4,7.5-7.5
                                C389.6,380.7,386.2,377.3,382.1,377.3z"/>
                        </g>
                        </svg>
                    <div className={'cort-number-1'}>1</div>
                </div>
                <div className={'cort-choice-2'} onClick={() => changeCort(2)}>
                    <svg version="1.1" id="Layer_11" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
                         viewBox="0 0 429.8 804.5">
                        <g>
                            <rect x="-187.4" y="187.5" transform="matrix(6.123234e-17 -1 1 6.123234e-17 -187.3548 617.1613)" className={selectedCort===2 ? 'cort-svg-selected' : 'cort-svg-not-selected'} width="804.6" height="429.6"/>
                        </g>
                        <g>
                            <path className="cort-svg-white-lines" d="M363,64H62.9v319.8h-5.1v2h5.1v318.5H363V385.8h1.2v-2H363V64z M320.5,551.2H216.6V385.8h0.5v-2h-0.5V218.1
                                h103.9V551.2z M212.6,383.8h-7.7v2h7.7v165.4H107.4V385.8H119v-2h-11.7V218.1h105.2V383.8z M107.4,555.2h213.1v139.1H107.4V555.2z
                                 M320.5,214.1H107.4V74h213.1V214.1z M72.9,74h30.5v620.3H72.9V74z M353,694.3h-28.5V74H353v309.8h-1.1v2h1.1V694.3z"/>
                            <rect x="302.9" y="383.8" className="cort-svg-white-lines" width="12.3" height="2"/>
                            <rect x="180.3" y="383.8" className="cort-svg-white-lines" width="12.3" height="2"/>
                            <rect x="278.4" y="383.8" className="cort-svg-white-lines" width="12.3" height="2"/>
                            <rect x="253.9" y="383.8" className="cort-svg-white-lines" width="12.3" height="2"/>
                            <rect x="229.3" y="383.8" className="cort-svg-white-lines" width="12.3" height="2"/>
                            <rect x="327.4" y="383.8" className="cort-svg-white-lines" width="12.3" height="2"/>
                            <rect x="155.8" y="383.8" className="cort-svg-white-lines" width="12.3" height="2"/>
                            <rect x="82.3" y="383.8" className="cort-svg-white-lines" width="12.3" height="2"/>
                            <rect x="131.3" y="383.8" className="cort-svg-white-lines" width="12.3" height="2"/>
                            <path className="cort-svg-white-lines" d="M39.9,377.3c-4.2,0-7.5,3.4-7.5,7.5c0,4.2,3.4,7.5,7.5,7.5c4.2,0,7.5-3.4,7.5-7.5
                                C47.4,380.7,44,377.3,39.9,377.3z"/>
                            <path className="cort-svg-white-lines" d="M382.1,377.3c-4.2,0-7.5,3.4-7.5,7.5c0,4.2,3.4,7.5,7.5,7.5c4.2,0,7.5-3.4,7.5-7.5
                                C389.6,380.7,386.2,377.3,382.1,377.3z"/>
                        </g>
                    </svg>
                    <div className={'cort-number-2'}>2</div>
                </div>
            </div>
        </div>
    );
};

export default CortsChoice;